import React from "react"
import ReactDOM from "react-dom/client"
import { HelmetProvider } from "react-helmet-async"
import { Provider as UrqlProvider } from "urql"
import { Toaster } from "@/components/ui/toaster.tsx"
import { TooltipProvider } from "@/components/ui/tooltip.tsx"
import { CurrentUserProvider } from "@/lib/CurrentUserProvider.tsx"
import { auth } from "@/lib/firebase.ts"
import { createUrqlClient } from "@/lib/urql.ts"
import { Routes } from "./router.tsx"
import "./global.css"

type AppUrqlProviderProps = {
  children: React.ReactNode
}

const AppUrqlProvider = ({ children }: AppUrqlProviderProps) => {
  const [client, setClient] = React.useState(() => createUrqlClient())
  const previousUserIdRef = React.useRef(auth.currentUser()?.uid ?? null)

  React.useEffect(
    () =>
      auth.onAuthStateChanged((authUser) => {
        const nextUserId = authUser?.uid ?? null
        if (previousUserIdRef.current === nextUserId) return

        previousUserIdRef.current = nextUserId
        setClient(createUrqlClient())
      }),
    []
  )

  return <UrqlProvider value={client}>{children}</UrqlProvider>
}

const enableMocking = async () => {
  // if (import.meta.env.DEV) {
  //   const { worker } = await import("./mocks/browser");
  //   // `worker.start()` returns a Promise that resolves
  //   // once the Service Worker is up and ready to intercept requests.
  //   return worker.start();
  // }
}

enableMocking().then(() => {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <HelmetProvider>
        <CurrentUserProvider>
          <AppUrqlProvider>
            <TooltipProvider>
              <Routes />
            </TooltipProvider>
          </AppUrqlProvider>
        </CurrentUserProvider>
      </HelmetProvider>
      <Toaster />
    </React.StrictMode>
  )
})
